import styles from "./styles.module.css";

const Tabs = ({
  tabs = [],
  selectedTab,
  onChange,
  className = "",
  ...props
}) => {
  return (
    <div className={`${styles.tabsContainer} ${className}`} {...props}>
      <div className={styles.tabsList}>
        {tabs.map((tab) => (
          <button
            key={tab.value}
            onClick={() => onChange(tab.value)}
            className={`${styles.tab} ${
              selectedTab === tab.value ? styles.selected : styles.unselected
            }`}
            type="button"
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Tabs;
